/** Created by azhou on 2019/3/23.*/
<template>
  <div>
    <public-title>编辑认证</public-title>
    <div class="load-area">
      <el-tabs v-model="activeName" @tab-click="handClick">
        <el-tab-pane :name="item.id" v-for="item in tabArr" :key="item.id">
          <label slot="label">{{item.name}}
            <!-- <span class="unread-msg" v-if="item.unRead>0">{{item.unRead}}</span> -->
          </label>
        </el-tab-pane>
      </el-tabs>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else>
        <div v-if="activeName == 4">
          <ul class="list-head mt-3"><li class="w-50" v-for="item in tourArr" :key="item">{{item}}</li></ul>
          <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
            <li class="w-50 list-item-col">{{item.title}}</li>
            <li class="w-50 list-item-col">{{item.sex | formatVar('sex')}}</li>
            <li class="w-50 list-item-col">{{item.id_card}}</li>
            <li class="w-50 list-item-col">{{item.mobile}}</li>
            <li class="w-50 list-item-col">{{item.time | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col text-link" @click="verifyUser(item)" >去审核</li>
          </ul>
        </div>
        <div v-else>
          <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
          <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
            <li class="w-50 list-item-col">{{item.title}}</li>
            <li class="w-50 list-item-col">编辑认证</li>
            <li class="w-50 list-item-col">{{item.contact || '集团账号'}}</li>
            <li class="w-50 list-item-col">{{item.mob}}</li>
            <li class="w-50 list-item-col">{{item.group_name || '非集团门店'}}</li>
            <li class="w-50 list-item-col">{{item.submit_time | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col-end flex-wrap">
              <span class="text-link" @click="verifyUser(item)">去审核</span>
            </li>
          </ul>
        </div>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapActions,mapState,mapMutations } from 'vuex'

  export default {
    name: 'VerifyStore',
    computed: {
      ...mapState(['AdminDataLists','waitVerify']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      tabArr() {
        let list = this.$GVAR.StoreType.slice(0,2);
        list.forEach(v => {
          v.id = v.id + '';
          v.unRead = this.waitVerify[v.en]
        });
        return list;
      }
    },
    data() {
      return {
        activeName:'2',
        titleArr:['门店名称','审核类型','注册人','注册电话','集团名称','提交时间','操作'],
        tourArr: ['真实姓名','性别','身份证号','手机号','提交时间','操作']
      }
    },
    created() {
      if (this.queryCon.storeType) this.activeName = this.queryCon.storeType + '';
      this.getDataLists();
    },
    beforeDestroy() {
      //更新当前查看门店id
      this.UPDATECURRENTSTORE({ type:'', storeId: '' })
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getAdminDataLists']),
      handClick() {
        this.$router.push({name:this.$route.name,query:{storeType:this.activeName}})
        this.$GFUN.pageChange(1);
        this.getDataLists()
      },
      //获取待审核用户列表
      getDataLists() {
        // this.UPDATECURRENTSTORE({type:});
        let data = {
          ...this.queryCon,
          confirm:true,
          type:Number(this.activeName)
        }
        if (this.activeName == 4) { data.store_type = 4 }
        else data.storeType = Number(this.activeName)
        this.getAdminDataLists({
          type:'storeList',
          data
        });
      },
      verifyUser(item) {
        // 品牌馆权限
        //if (!this.$GFUN.powerIsInArray([47,48,136,424])) { this._alert('您没有相关权限！',null,'error'); return; }
        let {id} = item;
        this.$router.push({name:'StoreDetail',query:{id,type:this.activeName,confirm:1}})
      }
    }
  }
</script>
<style lang="scss" scoped>
  .unread-msg{
    top: 5px;
    left: 48px;
  }
</style>
